import { Flex, IconButton, Input } from '@lego/klik-ui';
import { Edit } from '@lego/klik-ui/icons';
import type { ChangeEvent, KeyboardEvent, ReactNode } from 'react';
import { EditButtons } from '@/components/common/EditButtons';
import { TextHeader } from './TextHeader';

type Props = {
  title: string;
  editingKey: string | null;
  isSaving: boolean;
  editedValue: string;
  onStartEdit: (key: string, currentValue: ReactNode) => void;
  onCancel: () => void;
  onSave: (key: string, value?: string) => Promise<void>;
  onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>, key: string) => void;
};

export const EditableDetailsHeader = ({
  title,
  editingKey,
  isSaving,
  editedValue,
  onStartEdit,
  onCancel,
  onSave,
  onInputChange,
  onKeyDown,
}: Props) => {
  const isEditing = editingKey === 'Name';
  const isUnchanged = title === editedValue;

  if (isEditing) {
    return (
      <Flex align="center" gap={2} mb={4}>
        <Input
          autoFocus
          maxWidth="400px"
          onChange={onInputChange}
          onKeyDown={(e) => onKeyDown(e, 'Name')}
          size="sm"
          value={editedValue}
        />
        <EditButtons
          isEditing={isEditing}
          isSaving={isSaving}
          onCancel={onCancel}
          onSave={() => onSave('Name', editedValue)}
          saveDisabled={isUnchanged}
        />
      </Flex>
    );
  }

  return (
    <Flex align="center" gap={2} mb={4}>
      <TextHeader tagLevel="h3" title={title} />
      <IconButton
        aria-label="Edit name"
        color="LinkText"
        icon={<Edit />}
        onClick={() => onStartEdit('Name', title)}
        paddingBottom="2"
        size="xs"
        variant="solid"
      />
    </Flex>
  );
};
